type returnShape = {
    isIPad: boolean;
    isIPhone: boolean;
    isAndroid: boolean;
    isChrome: boolean;
    isMobile: boolean;
    getOldIOSKeyboardHeight: () => number;
    version: number;
    safariVersion: number | null;
};

const UADetector = (): returnShape => {
    const ua = window.navigator.userAgent;

    const isIPad =
        !!ua.match(/iPad/i) ||
        !!(
            /Macintosh/i.test(navigator.userAgent) &&
            navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 1
        );
    const isIPhone = !!ua.match(/iPhone/i);

    const isAndroid = ua.toLowerCase().indexOf('android') > -1;

    const isChrome = ua.indexOf('Chrome') > -1;
    const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            ua,
        );

    // user agent "Mozilla/5.0 (iPhone; CPU iPhone OS 18_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/26.0 Mobile/15E148 Safari/604.1"
    const safariVersionMatch = ua.match(/Version\/(\d+)\./);
    const safariVersion = safariVersionMatch
        ? parseInt(safariVersionMatch[1], 10)
        : null;

    const versionStr = navigator?.userAgent?.split('iPhone OS ')[1] ?? '0';

    const version = parseInt(versionStr.substring(0, 2));

    const getOldIOSKeyboardHeight = (): number => {
        if (!isIPhone) {
            return 0;
        }

        if (!version || version > 12) {
            return 0;
        }

        const screenHeight = window.screen.height;

        if (screenHeight < 800) {
            return 260;
        } else if (screenHeight < 850) {
            // setting 345 for now
            return 325;
        }

        return 345;
    };

    return {
        isIPad,
        isIPhone,
        isAndroid,
        isChrome,
        isMobile,
        getOldIOSKeyboardHeight,
        version,
        safariVersion,
    };
};

export default UADetector;
